import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import type { ApiError } from '../types/common';

export interface DashboardStats {
  totalConsumers: number;
  totalTherapists: number;
  completedBookings: number;
  totalRevenueCents: number;
  pendingVerifications: number;
}

const dashboardKeys = {
  all: ['admin-dashboard'] as const,
  stats: () => [...dashboardKeys.all, 'stats'] as const,
};

async function fetchDashboardStats(): Promise<DashboardStats> {
  const response = await apiClient.get<DashboardStats>('/admin/dashboard/stats');
  return response.data;
}

export function useAdminDashboardStats() {
  return useQuery<DashboardStats, ApiError>({
    queryKey: dashboardKeys.stats(),
    queryFn: fetchDashboardStats,
    staleTime: 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });
}
